export const getCanSetFilter = (quickFilters, defaultQuickFilters) => {
	let canSetFilter = true;

	for (let i = 0; i < defaultQuickFilters.length; i++) {
		const filter = defaultQuickFilters[i];
		const filterValue = quickFilters[filter.id];
		const filterType = filter.type;

		if (filterType === "dateRange" && filterValue !== null) {
			if (filterValue.start || filterValue.end) {
				if (!filterValue.start || !filterValue.end) {
					canSetFilter = false;
					break;
				}
			}
		}
	}

	return canSetFilter;
};
